import React, { Component } from "react";
//import axios from 'axios';

import KFormField from "../components/onboarding/kFormField";
import { Grid } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import Box from "@material-ui/core/Box";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import TextField from '@material-ui/core/TextField';
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";


import Students from "../components/onboarding/students";
import KDateField from "../components/onboarding/kDateField";

// import Promotions from "../components/onboarding/promotions";

import KDialog from "../components/kdialog";
import misc from "../utils/misc";

import KCard from "../components/kCard";

let studentNameRequiredmsg = "Student Name is required";

let promoVoidTitle = "Promotions void!";
let promoVoidMessage = `Your promotions expire on {date}. You will loose promotions if you start classes after that.`;

let validatedFieldsOrg = [
  //  { id: 'studentName', msg: studentNameRequiredmsg },
  // check constructor before updating this array. speially order.
  // we remove extra student validators in ctor.
  { id: "parentName", msg: "Parent/Guardian Name is required" }, // ,
  /*
  { id: 'student_0', msg: studentNameRequiredmsg },
  { id: 'student_1', msg: studentNameRequiredmsg },
  { id: 'student_2', msg: studentNameRequiredmsg },
  { id: 'student_3', msg: studentNameRequiredmsg }  */
];

let validatedFields = []; // this is subset of validatedFieldsOrg, as per number of students.

export default class StepStudentInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      parentName: props.getStore().user.parentName,
      students: props.getStore().user.students,
      startDate: props.getStore().user.startDate,      
    };
    //this._validateOnDemand = true;
    this.isValidated = this.isValidated.bind(this);
    this.onInputValueChanged = this.onInputValueChanged.bind(this);
    this.onStudentsValueChanged = this.onStudentsValueChanged.bind(this);

    // remove extra validation fields,
    validatedFields = validatedFieldsOrg.map((x) => x);
    for (let i = 0; i < this.state.students.length; i++) {
      let id = `student.${i}.name`;
      validatedFields.push({ id, msg: studentNameRequiredmsg });
      //validatedFields = validatedFields.filter( el => el.id !== id);
    }
    this.options = props.getStore().user.options; // this is read only. no state required.

    if (!this.options) this.options = {};
    this.promotions = props.getStore().user.promotions;
    this.hasPromotions =
      this.promotions &&
      this.promotions.items &&
      this.promotions.items.length > 0;
    this.notesForParent = props.getStore().user.notesForParent;
 
  }

  isValidated() {
    let isDataValid = false;
    const userInput = this._grabUserInput();

    // const userInputCopy = Object.assign({}, userInput);
    const validateNewInput = this._validateData(userInput);
    //console.log('validateNewInput', validateNewInput);
    if (
      Object.keys(validateNewInput).every((k) => {
        return validateNewInput[k].valid === true;
      })
    ) {
      isDataValid = true;
      let user = Object.assign({}, this.props.getStore().user, userInput);
      let stData = { user: user };
      this.props.updateStore({
        ...stData,
        savedToCloud: false,
      });
    } else {
      // this.setState(Object.assign(userInput, validateNewInput, this._validationErrors(validateNewInput)));
    }
    return isDataValid;
  }

  _validateData(data) {
    let result = {};
    var _this = this;
    validatedFields.forEach(function (val, index) {
      // let a = _this.validateOne(data, val.id);
      let a = _this.onValueRequiredValidate(val.id, data[val.id], true);
      result = Object.assign(result, { [val.id]: a });
    });

    // special handling for students array
    let index = 0;
    data.students.forEach((s) => {
      let prop = `student.${index}.name`;
      let a = _this.onValueRequiredValidate(prop, s.name, true);
      result = Object.assign(result, { [prop]: a });
      index++;
    });
    return result;
  }

  _grabUserInput() {
    let ret = {
      parentName: this.state.parentName,
      students: this.state.students,
      startDate: this.state.startDate,
    };
    // this is for local verification.  not used in server
    // let index = 0;
    // this.state.students.forEach(m => { ret[`student_${index}`] = m; index++ });
    return ret;
  }

  onStudentsValueChanged = (index, value) => {
    //console.log('stepStudneInfo. changed')
    //console.log(index, value);

    this.setState((state) => {
      const students = state.students.map((item, j) => {
        if (j === index) {
          return value;
        } else {
          return item;
        }
      });
      return {
        students,
      };
    });
  };

  setPromoNAStatus(na) {
    if (this.hasPromotions === true) {
      let exp = { promoNA: na };
      let user = Object.assign({}, this.props.getStore().user, exp);
      let stData = { user: user };
      this.props.updateStore({
        ...stData,
        savedToCloud: false,
      });
    }
  }

  onStartDateChanged = (id, value) => {
    if (
      this.promotions.expires &&
      value.getTime() > this.promotions.expires.getTime()
    ) {
      let alertMessages = [];
      let msg = promoVoidMessage.replace(
        "{date}",
        misc.dateHelper.format(this.promotions.expires)
      );
      alertMessages.push(msg);
      this.setState((state, props) => {
        return { showAlert: true, alertMessages: alertMessages };
      });
      this.setPromoNAStatus(true);
    } else this.setPromoNAStatus(false);
    this.setState({ [id]: value });
  };

  onInputValueChanged = (id, value) => {
    this.setState({ [id]: value });
  };

  onValueRequiredValidate = (id, value, updateState) => {
    let attrib = "message"; //id + 'ValMsg';
    if (value === undefined)
      return { valid: false, [attrib]: "Value Required." };

    let valid = value !== "";

    let msg = "";
    if (!valid) msg = validatedFields.find((o) => o.id === id).msg;

    if (updateState) {
      this.setState((state, props) => {
        return { [attrib]: msg };
      });
    }
    let ret = { valid, [attrib]: msg };
    return ret;
  };

  onAlertClose = () =>
    this.setState((state, props) => {
      return { showAlert: false };
    });

  alertDlg = () =>
    this.state.showAlert ? (
      <KDialog
        onAlertClose={this.onAlertClose}
        showAlert={true}
        title={promoVoidTitle}
        messages={this.state.alertMessages}
      />
    ) : (
      ""
    );

  loading = () => (this.state.busy ? <CircularProgress /> : "");
  userMessage = () =>
    this.state.userMsg === "" ? (
      ""
    ) : (
      <div className="alert alert-warning">{this.state.userMsg}</div>
    );

  getSubHeading() {
    if (
      this.options &&
      this.options.editStartDate === true &&
      this.options.editSubjects === true
    )
      return "Update the Name(s) and Start Date as required.";
    return "Please contact center if you want to change Start Date and/or Subjects before proceeding further.";
  }

  renderPromotions() {
    /*
    return this.hasPromotions === false ? '' :        
      <div className="container">
        <div className="row justify-content-md-center">
          <div className="col-md-auto">
            <Promotions promotions={this.promotions} />
          </div>
        </div>
      </div>
      */
    return null;
  }

  getGridMargin() {

  }

  getStartDateText() {
    let d = misc.dateHelper.parseDate(this.state.startDate);
    let d1 = misc.dateHelper.format2(d);
    return d1;
  }

  render() {
    let center = this.props.getStore().center;
    let dateExtras = {
      centerDays: center.centerDays,
      disabledDates: center.disabledDates,
    };
    return (
      <div className="step step2">
        <div>
          <KCard>
            <form id="Form" className="form-horizontal">
              {this.renderPromotions()}
              <div className="form-groupaa row">
                <label className="col-md-12 control-label">
                  <Typography variant="h5">Student Information</Typography>
                </label>
              </div>
              <div className="aaamt-3 lead">
                <Typography variant="subtitle1">
                  {this.getSubHeading()}
                </Typography>
              </div>
              <div className="mt-3"></div>
              <Divider />           
              <Box m='auto'>
                <List>
                  { this.notesForParent.length > 0 &&
                    <ListItem>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={12}>
                          <TextField style={{ minWidth: 240 }} fullWidth
                            value={ this.notesForParent }
                            id={`notesForParent`}                       
                            label="Note from Center"                          
                            multiline                           
                            variant="outlined"
                            InputProps={{
                                readOnly:true
                              }}                
                            />
                          </Grid>
                      </Grid>
                    </ListItem>
                  }

                  <ListItem>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <KFormField
                          id="parentName"
                          onChange={this.onInputValueChanged}
                          validator={this.onValueRequiredValidate}
                          layout="horizontal"
                          label="Parent/Guardian Name"
                          value={this.state.parentName}
                          autoFocus
                          fullWidth
                          placeholder="Parent/Guardian Name"
                          errorMsg={this.state.parentNameValMsg}
                        ></KFormField>
                      </Grid>
                      <Grid item xs={12} sm={6}>            
                        { 
                          this.options.editStartDate &&          
                          <KDateField
                            id={`startDate`}
                            small="true"
                            label={`Start Date}`}
                            layout="horizontal"
                            value={this.state.startDate}
                            dateExtras={dateExtras}
                            readOnly={!this.options.editStartDate}
                            onChange={this.onStartDateChanged}
                          ></KDateField>
                        }
                        { !this.options.editStartDate &&          
                           <TextField style={{ minWidth: 240 }} fullWidth
                           value={this.getStartDateText()}
                           id={`startDate`}                       
                           label="Start Date"                           
                           helperText=""
                           variant="outlined"
                           InputProps={{
                               readOnly:true
                             }}                
                           >                         
                       </TextField>
                        }
                      </Grid>
                    </Grid>
                  </ListItem>
                </List>

                <Divider />

                <Box pt={2} pb={2} pl={2} pr={2}>
                  <Students
                    validator={this.onValueRequiredValidate}
                    readOnly={!this.options.editSubjects}
                    onChange={this.onStudentsValueChanged}
                    students={this.state.students}
                  />
                </Box>
              </Box>
            </form>
          </KCard>
          {this.alertDlg()}
        </div>
      </div>
    );
  }
}
